import { CompanyUrlsArray } from 'containers/HomePage/Data';
import React, { useEffect, useState } from 'react';
import { useHistory, Prompt } from 'react-router-dom';
import { handleCompanyUrl } from 'utils/organizationUtils';

export default function PromptComponent(): any {
  const history = useHistory();
  const [isDirty, setIsDirty] = useState<boolean>(false);
  useEffect(() => {
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };
    if (CompanyUrlsArray.includes(history.location.pathname)) {
      window.addEventListener('beforeunload', onBeforeUnload);
    }
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [isDirty, history.location.pathname]);

  const onReload = () => {
    setIsDirty(true);
    history.replace(handleCompanyUrl('/dashboards'));
  };
  window.addEventListener('unload', onReload);
  return (
    <>
      <Prompt when={isDirty} message='Are you sure you want to leave? You have unsaved changes.' />
    </>
  );
}
